// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"2e1f3922","394":"4538ebb4","410":"adb4fbd0","954":"443b33f0"}[chunkId] + ".chunk.css";
};